import { j as c } from "../../jsx-runtime-ClSzPYp4.js";
import s from "../BaseIcon.mjs";
const o = (e) => /* @__PURE__ */ c.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Meter",
  ...e,
  children: /* @__PURE__ */ c.jsx("g", {
    children: /* @__PURE__ */ c.jsx("path", {
      d: "M6.33,18.29L2.55,20.5c-2.03-3.55-2-7.72-0.28-11.05l3.97,2.37C5.24,13.76,5.2,16.19,6.33,18.29z   M11.58,3.5C9.83,3.55,8.11,4.06,6.5,5C4.89,5.94,3.61,7.24,2.7,8.75l3.97,2.37c0.54-0.82,1.26-1.53,2.16-2.06   c0.89-0.52,1.77-0.85,2.75-0.92V3.5z M12.19,13c-0.06-0.01-0.13-0.02-0.19-0.02c-0.8,0-1.45,0.66-1.45,1.47   c0,0.81,0.65,1.47,1.45,1.47s1.45-0.66,1.45-1.47c0-0.22-0.05-0.43-0.14-0.61l1.59-3.4L12.19,13z M21.73,9.45l-3.97,2.37   c1,1.95,1.04,4.38-0.09,6.48l3.78,2.21C23.48,16.95,23.45,12.78,21.73,9.45z M17.48,5c-1.61-0.94-3.33-1.45-5.08-1.5v4.65   c0.97,0.06,1.85,0.39,2.75,0.92c0.9,0.52,1.63,1.23,2.16,2.06l3.97-2.37C20.37,7.24,19.09,5.94,17.48,5z"
    })
  })
}), l = (e) => /* @__PURE__ */ c.jsx(s, {
  IconSvg: o,
  ...e
});
export {
  l as default
};
